import { DATE_FORMAT } from '@constants';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Chip, IconButton, Link, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GridColDef } from '@mui/x-data-grid';

import dayjs from 'dayjs';
import { TableEnterpriseNewsWire } from './constants';

interface Props {
  onClickEdit: (row: TableEnterpriseNewsWire) => void;
  onClickDelete: (row: TableEnterpriseNewsWire) => void;
}
export function getNewsWireTableColumns({
  onClickEdit,
  onClickDelete,
}: Props): GridColDef<TableEnterpriseNewsWire>[] {
  return [
    {
      field: 'title',
      headerName: 'Analysis Title',
      flex: 2,
      sortable: false,
      renderCell: ({ row }) => (
        <Tooltip title={row.title}>
          <Typography className="ellipsis" color="#3369E8">
            {row.title}
          </Typography>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'url',
      headerName: 'Url',
      flex: 1.2,
      sortable: false,
      renderCell: ({ row }) => (
        <Tooltip title={row.url}>
          <Link className="ellipsis" href={row.url} target="_blank">
            {row.url}
          </Link>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'imageUrl',
      headerName: 'Image Url',
      flex: 1.2,
      sortable: false,
      renderCell: ({ row }) => (
        <Tooltip title={row.imageUrl}>
          <Link className="ellipsis" href={row.imageUrl || ''} target="_blank">
            {row.imageUrl}
          </Link>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'label',
      headerName: 'Label',
      sortable: false,
      flex: 1,
      renderCell: ({ row }) => <Chip color="default" label={row.label} />,
      resizable: false,
    },
    {
      field: 'dateOfAddition',
      headerName: 'Date of addition',
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }) => dayjs(row.createdAt).format(DATE_FORMAT),
      resizable: false,
    },

    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <Box>
          <IconButton onClick={() => onClickEdit(row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => onClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ),
      resizable: false,
    },
  ];
}
